import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { useCourses } from '../courses/Courses';
import { useGrades } from '../grades/Grades';
import { useInstitutions } from '../institutions/Institutions';
import { useSeries } from '../series/Series';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
    width: '50%',
  },
  a: {
    alignSelf: 'flex-end',
    marginRight: '50px',
  },
}));

function useForm() {
  const [entries, setEntries] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (e.target.type === 'file') {
      setEntries({
        ...entries,
        [name]: e.target.files[0],
      });
    } else {
      setEntries({ ...entries, [name]: value });
    }
  };

  return {
    handleChange,
    entries,
  };
}

export function MasiveCharge(props) {
  const { institutions } = useInstitutions();
  const { series } = useSeries();
  const { grades } = useGrades();
  const { courses, setCourses } = useCourses();
  const { handleChange, entries } = useForm();
  const templateFileRef = useRef();
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    if (entries?.grade) {
      fetch(`https://api.edicionesmilenio.com/api/courses/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          grade: entries?.grade,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          setCourses(data?.data);
        });
    }
  }, [entries?.grade, setCourses]);

  const charge = () => {
    const formData = new FormData();
    formData.append('template', templateFileRef?.current?.files[0]);
    formData.append('institution', entries?.institution);
    formData.append('grade', entries?.grade);
    formData.append('course', entries?.course);
    if (entries?.series?.length > 0) {
      entries?.series?.forEach((serie) => {
        formData.append('series', serie);
      });
    }
    fetch('https://api.edicionesmilenio.com/api/students/charge', {
      method: 'POST',
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        navigate('/admin/students');
      });
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <a
        href="https://api.edicionesmilenio.com/files/chargetemplate.xlsx"
        className={classes.a}
      >
        Descarga aquí la plantilla
      </a>
      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="demo-simple-select-outlined-label">
          Institución
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={entries?.institution || ''}
          onChange={handleChange}
          label="Institución"
          name="institution"
        >
          {institutions.map((institution) => (
            <MenuItem value={institution?._id}>{institution?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="demo-simple-select-outlined-label">
          Series a activar
        </InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={entries?.series || []}
          onChange={handleChange}
          label="Series a activar"
          name="series"
          multiple
        >
          {series.map((serie) => (
            <MenuItem value={serie?._id}>{serie?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="demo-simple-select-outlined-label">Grado</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={entries?.grade || ''}
          onChange={handleChange}
          label="Grado"
          name="grade"
        >
          {grades.map((grade) => (
            <MenuItem value={grade?._id}>{grade?.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" className={classes.input}>
        <InputLabel id="demo-simple-select-outlined-label">Curso</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={entries?.course || ''}
          onChange={handleChange}
          label="Curso"
          name="course"
        >
          {courses.map((course) => (
            <MenuItem
              value={course?._id}
            >{`${course?.numericName} (${course?.alphaName})`}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <div
        className={classes.input}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50px',
          cursor: 'pointer',
          background: '#ddd',
          borderRadius: '5px',
        }}
        onClick={() => templateFileRef.current.click()}
      >
        <input
          type="file"
          name="template"
          onChange={handleChange}
          style={{ display: 'none' }}
          ref={templateFileRef}
          accept=".xlsx"
        />
        {!entries?.template && (
          <span style={{ color: '#777' }}>Cargar plantilla</span>
        )}
        {entries?.template && (
          <span style={{ color: '#777' }}>{entries?.template?.name}</span>
        )}
      </div>
      <Button
        variant="contained"
        color="primary"
        className={classes.input}
        onClick={charge}
        disabled={
          !entries?.institution ||
          !entries?.grade ||
          !entries?.course ||
          !entries?.template
        }
      >
        Cargar
      </Button>
    </div>
  );
}
